import type { ReactNode, RefObject } from "react";

import { AnchoredDialogShell } from "@/components/sdk-shells";

interface ViewerAnchoredDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  triggerRef?: RefObject<HTMLElement | null>;
  title: string;
  children: ReactNode;
  contentClassName?: string;
  overlayClassName?: string;
  topPaddingPx?: number;
  modal?: boolean;
  closeOnOutsideInteract?: boolean;
  placement?: "anchor" | "right";
  sideOffsetPx?: number;
}

export function ViewerAnchoredDialog({
  open,
  onOpenChange,
  triggerRef,
  title,
  children,
  contentClassName = "",
  overlayClassName = "z-[11990] bg-transparent",
  topPaddingPx = 10,
  modal = true,
  closeOnOutsideInteract = true,
  placement = "anchor",
  sideOffsetPx = 24,
}: ViewerAnchoredDialogProps) {
  return (
    <AnchoredDialogShell
      open={open}
      onOpenChange={onOpenChange}
      triggerRef={triggerRef}
      title={title}
      contentClassName={contentClassName}
      overlayClassName={overlayClassName}
      topPaddingPx={topPaddingPx}
      modal={modal}
      closeOnOutsideInteract={closeOnOutsideInteract}
      placement={placement}
      sideOffsetPx={sideOffsetPx}
    >
      {children}
    </AnchoredDialogShell>
  );
}
